import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AccountRelatedDTO } from "src/app/accounts/Account";
import { AccountAppDTO } from "src/app/apps/AccountApp";
import { SessionService } from "src/app/session.service";

//Eventuually move this to the DB
const LOGO_MAP: { [key: string]: string } = {
  "Ella Bliss": "assets/svg/logos/ellaBliss.svg",
  TripChat: "assets/svg/logos/tripChat.svg",
  "Twin Pine Casino & Resort": "assets/svg/logos/twinPine.svg",
  Evergreen: "assets/svg/logos/evergreen.svg",
  AOT: "assets/svg/logos/aot.svg",
  "Blackbird Bend Casino": "assets/svg/logos/blackbird.svg",
};

class AccountSelection {
  logo?: string;
  constructor(
    private accountRelatedDTO: AccountRelatedDTO,
    public selected: boolean = false,
  ) {
    this.logo = LOGO_MAP[this.accountName];
  }

  get accountName() {
    return this.accountRelatedDTO.name;
  }

  get accountID() {
    return this.accountRelatedDTO.id;
  }
}

@Component({
  selector: "app-accounts-selection",
  templateUrl: "./accounts-selection.component.html",
  styleUrls: ["./accounts-selection.component.scss"],
})
export class AccountsSelectionComponent implements OnInit {
  accounts!: AccountSelection[];
  constructor(
    private SessionService: SessionService,
    private Router: Router,
    private ActivatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const availableAccounts = this.SessionService.accounts!.filter(
      (account) => {
        return account.apps.length;
      },
    );

    this.accounts = availableAccounts!.map((account) => {
      return new AccountSelection(account);
    });

    this.accounts.push(
      new AccountSelection({
        name: "All Accounts",
        id: "all",
        apps: [{ id: null } as any as AccountAppDTO],
      } as any as AccountRelatedDTO),
    );
  }

  get openDisabled() {
    return !this.accounts.find((account) => account.selected);
  }

  get selectedAccounts() {
    return this.accounts.filter((account) => {
      return account.selected;
    });
  }

  get selectedAccountIDs() {
    return this.selectedAccounts.map((account) => {
      return account.accountID;
    });
  }

  changeSelection(account: AccountSelection) {
    account.selected = !account.selected;
  }

  goToView() {
    this.Router.navigate(["view"], {
      relativeTo: this.ActivatedRoute.parent!.parent,
      queryParams: { account: this.selectedAccountIDs },
    });
  }
}
